import { useExceptionEvidence } from '../exceptions/api';
import s from './OrderExceptionEvidence.module.css';

/** 异常凭证关联 V2 索引及 V1 共用订单附件，按需读取当前可见异常。 */
export function OrderExceptionEvidence({ orderId, exceptionId }: { orderId: string; exceptionId: string }) {
  const evidence = useExceptionEvidence(orderId, exceptionId);
  if (!evidence.items.length) return null;
  return <div className={s.photos} aria-label="异常凭证照片">{evidence.items.filter((file) => /^\/uploads\/[^/?#]+$/.test(file.fileUrl)).slice(0, 9).map((file) => <a key={file.evidenceId} href={file.fileUrl} target="_blank" rel="noopener noreferrer" title={file.label}><img src={file.fileUrl} alt={file.label} loading="lazy" /><span>{file.label}</span></a>)}</div>;
}
